export default __webpack_public_path__ + "static/media/prize.ec6a75e7.png";